/* Arquetypo · CRO Bayón · 15-sep-2026
   1) Mantiene al día la barra de envío gratis cuando cambia el carrito.
   2) Botón fijo "Proceder al pago" en el carrito móvil. */
(function () {
  function pesos(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function pintar(cart) {
    document.querySelectorAll('[data-arq-envio]').forEach(function (el) {
      var umbral = parseInt(el.getAttribute('data-umbral'), 10) || 0;
      var total = cart.total_price || 0;
      var txt = el.querySelector('[data-arq-envio-txt]');
      var fill = el.querySelector('[data-arq-envio-fill]');
      if (!umbral) return;
      if (total >= umbral) {
        txt.innerHTML = '<b>Tu pedido ya tiene envío gratis.</b>';
      } else {
        txt.innerHTML = 'Te faltan <b>' + pesos(umbral - total) + '</b> para envío gratis.';
      }
      if (fill) fill.style.width = Math.max(0, Math.min(100, Math.round(total * 100 / umbral))) + '%';
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var sub = document.querySelector('[data-arq-cart-total]');
    if (sub) sub.textContent = pesos(cart.total_price || 0);
    var fixed = document.querySelector('.arq-cart-fixed');
    if (fixed) fixed.hidden = !(cart.item_count > 0);
  }
  function refrescar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(pintar)
      .catch(function () {});
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refrescar, 150); }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-arq-checkout]');
    if (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById('ArqCartForm');
        if (!form) return;
        var real = form.querySelector('button[name="checkout"]');
        if (real) real.click();
      });
    }
  });
})();

/* "Para coser esto": agrega al carrito y refresca el cajón como lo hace el tema */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-arq-add]'); if (!b) return;
  e.preventDefault(); if (!b.dataset.arqTxt) b.dataset.arqTxt = b.textContent; b.disabled = true; b.textContent = '…';
  var fd = new FormData(); fd.append('id', b.getAttribute('data-arq-add')); fd.append('quantity', b.getAttribute('data-arq-qty') || '1');
  var secs = (window.FoxKitSections || ['cart-drawer', 'cart-icon-bubble']).join(',');
  fd.append('sections', secs); fd.append('sections_url', window.location.pathname);
  fetch(window.MinimogSettings && window.MinimogSettings.routes ? window.MinimogSettings.routes.cart_add_url : '/cart/add', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status) { b.disabled = false; b.textContent = b.dataset.arqTxt; var m = b.parentElement.querySelector('[data-arq-add-msg]'); if (!m) { m = document.createElement('p'); m.setAttribute('data-arq-add-msg', ''); m.style.cssText = 'margin:8px 0 0;font-size:13px;color:#c8372a;text-align:center'; b.insertAdjacentElement('afterend', m); } m.textContent = res.description || res.message || 'No se pudo agregar; inténtalo de nuevo.'; return; }
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: res });
      else window.location.reload();
    })
    .catch(function () { b.disabled = false; b.textContent = b.dataset.arqTxt; });
});

/* Sucursales: vista previa al pasar el mouse y video en grande al clic */
(function () {
  document.addEventListener('mouseover', function (e) {
    var it = e.target.closest('.arq-suc__item'); if (!it) return;
    var v = it.querySelector('[data-arq-suc-peek] video'); if (v && v.paused) { v.play().catch(function(){}); }
  });
  document.addEventListener('mouseout', function (e) {
    var it = e.target.closest('.arq-suc__item'); if (!it || it.contains(e.relatedTarget)) return;
    var v = it.querySelector('[data-arq-suc-peek] video'); if (v) v.pause();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-arq-suc-play]'); if (!b) return;
    var src = b.parentElement.querySelector('[data-arq-suc-peek] video'); if (!src) return;
    var m = document.createElement('div'); m.className = 'arq-vmodal'; m.setAttribute('role', 'dialog');
    var v = src.cloneNode(true); v.muted = true; v.controls = true; v.loop = false; v.autoplay = true; v.removeAttribute('loop');
    var x = document.createElement('button'); x.className = 'arq-vmodal__x'; x.setAttribute('aria-label', 'Cerrar'); x.textContent = '\u00d7';
    m.appendChild(v); m.appendChild(x); document.body.appendChild(m); document.documentElement.style.overflow = 'hidden';
    v.play().catch(function(){});
    function close() { v.pause(); m.remove(); document.documentElement.style.overflow = ''; }
    x.addEventListener('click', close); m.addEventListener('click', function (ev) { if (ev.target === m) close(); });
    document.addEventListener('keydown', function esc(ev) { if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  });
})();

/* Hero: botón para activar/silenciar el sonido del video */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-arq-sound]'); if (!b) return;
  var v = b.parentElement.querySelector('video'); if (!v) return;
  var on = v.muted; v.muted = !on; if (on) { v.play().catch(function(){}); }
  b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Silenciar' : 'Activar sonido');
  b.querySelector('.arq-hero__sound-txt').textContent = on ? 'Silencio' : 'Sonido';
});

/* Tarjetas con video: reproducir solo mientras la tarjeta está en pantalla */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var box = en.target, v = box.querySelector('video'); if (!v) return;
      if (!v.dataset.arqBound) { v.dataset.arqBound = '1'; v.addEventListener('playing', function () { box.classList.add('is-on'); }); v.addEventListener('pause', function () { box.classList.remove('is-on'); }); }
      if (en.isIntersecting) {
        v.muted = true; v.setAttribute('autoplay', ''); v.setAttribute('preload', 'auto');
        var p = v.play(); if (p && p.catch) p.catch(function () { v.addEventListener('canplay', function () { v.play().catch(function(){}); }, { once: true }); try { v.load(); } catch (e) {} });
      } else { v.removeAttribute('autoplay'); v.pause(); }
    });
  }, { threshold: 0.35 });
  function arm() { document.querySelectorAll('[data-arq-card-video]:not([data-armed])').forEach(function (b) { b.setAttribute('data-armed', '1'); io.observe(b); }); }
  arm(); new MutationObserver(arm).observe(document.body, { childList: true, subtree: true });
})();

/* Artículos: agrupar productos citados consecutivos en una fila con scroll horizontal */
(function () {
  var c = document.querySelector('.arq-art__content'); if (!c) return;
  var nodes = Array.prototype.slice.call(c.children), i = 0;
  while (i < nodes.length) {
    if (nodes[i].classList && nodes[i].classList.contains('arq-prod')) {
      var j = i; while (j < nodes.length && nodes[j].classList && nodes[j].classList.contains('arq-prod')) j++;
      if (j - i >= 5) {
        var row = document.createElement('div'); row.className = 'arq-prod-row'; row.setAttribute('aria-label', 'Productos mencionados');
        c.insertBefore(row, nodes[i]); for (var k = i; k < j; k++) row.appendChild(nodes[k]);
        var hint = document.createElement('p'); hint.className = 'arq-prod-hint'; hint.textContent = (j - i) + ' telas · desliza para ver más'; c.insertBefore(hint, row);
      }
      i = j;
    } else i++;
  }
})();

/* "Avísame cuando llegue": suscripción back-in-stock en Klaviyo, sin app */
(function () {
  var box = document.querySelector('[data-arq-bis]'); if (!box) return;
  var form = box.querySelector('[data-arq-bis-form]'), msg = box.querySelector('[data-arq-bis-msg]');
  function variantId() { return box.getAttribute('data-variant'); }
  function sync(v) {
    if (!v) return;
    box.setAttribute('data-variant', v.id);
    box.hidden = v.available !== false;
    msg.textContent = ''; form.hidden = false;
  }
  if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, function (e) { sync(e && (e.variant || (e.data && e.data.variant))); });
  }
  document.addEventListener('variant:changed', function (e) { sync(e.detail && e.detail.variant); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (form.querySelector('input[name=email]').value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Escribe un correo válido.'; return; }
    var btn = form.querySelector('button'); btn.disabled = true; btn.textContent = 'Enviando…';
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + box.getAttribute('data-company'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
        profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId() } } } } })
    }).then(function (r) {
      if (r.ok || r.status === 202) { form.hidden = true; msg.textContent = 'Listo. Te escribimos en cuanto vuelva.'; }
      else { btn.disabled = false; btn.textContent = 'Avísame'; msg.textContent = 'No pudimos guardarlo. Inténtalo de nuevo.'; }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Avísame'; msg.textContent = 'No pudimos guardarlo. Inténtalo de nuevo.'; });
  });
})();
